import React from 'react';
import { getAssetPath } from '../../utils/assetHelper';

/**
 * AssetPreloader component
 * 
 * This component preloads all necessary images to ensure they are available
 * when needed throughout the application, especially for hover effects and transitions.
 */
const AssetPreloader: React.FC = () => {
  // Images to preload
  const imagesToPreload = [
    // Button backgrounds (standard and mobile)
    'assets/images/s-button-bg-1.png',
    'assets/images/s-button-bg-1-hover.png',
    'assets/images/s-button-bg-1-mobile.png',
    'assets/images/s-button-bg-2.png',
    'assets/images/s-button-bg-2-hover.png',
    'assets/images/s-button-bg-3.png',
    'assets/images/s-button-bg-3-hover.png',
    'assets/images/s-button-bg-3-mobile.png',
    
    // Button backlines
    'assets/images/s-button-backline.png',
    'assets/images/s-button-backline-2.png',
    'assets/images/s-button-backline-3.png',
    'assets/images/s-button-backline-mobile.png',
    'assets/images/s-button-backline-3-mobile.png',
    
    // Button level background
    'assets/images/s-button-lvl-bg.png',
    
    // Profile button and backline images
    'assets/images/profile-button.png',
    'assets/images/profile-button-hover.png',
    'assets/images/profile-button-backline.png',
    'assets/images/profile-button-mobile.png',
    'assets/images/profile-button-backline-mobile.png',
    
    // Sidebar menu icons
    'assets/images/s-m-dashboard.svg',
    'assets/images/s-m-wallet.svg',
    'assets/images/s-m-store.svg',
    'assets/images/s-m-settings.svg',
    'assets/images/s-m-help.svg',
    'assets/images/s-m-notifications.svg',
    'assets/images/s-m-logout.svg',
    
    // Icons
    'assets/images/valor-points-icon@1x.png',
    'assets/images/valor-points-icon@2x.png',
    'assets/images/phan-icon@1x.png',
    'assets/images/phan-icon@2x.png',
    'assets/images/dashboard-icon.svg',
    'assets/images/logo-white.svg',
    'assets/images/logo-icon.svg',
    'assets/images/avatar-1.png',
    'assets/images/avatar-2.png'
  ];

  // Create style for the hidden preloader
  const preloaderStyle: React.CSSProperties = {
    position: 'absolute',
    width: '0',
    height: '0',
    opacity: '0',
    visibility: 'hidden',
    pointerEvents: 'none',
  };

  // Generate background images string for CSS
  const backgroundImages = imagesToPreload
    .map(image => `url(${getAssetPath(image)})`)
    .join(', ');

  return (
    <div
      id="preloadedImages"
      style={{
        ...preloaderStyle,
        backgroundImage: backgroundImages,
      }}
      aria-hidden="true"
    />
  );
};

export default AssetPreloader; 